import PropTypes from "prop-types";
import React, { useState } from "react";
import Card from "react-bootstrap/Card";
import Collapse from "react-bootstrap/Collapse";
import ListGroup from "react-bootstrap/ListGroup";

const SupportIssue = ({ children, title }) => {
  const [open, setOpen] = useState(false);

  return (
    <ListGroup.Item
      onClick={() => setOpen((prev) => !prev)}
      style={{
        padding: 10,
        backgroundColor: "white",
        marginBottom: 5,
        cursor: "pointer",
      }}
    >
      <div>{title}</div>
      <Collapse in={open}>
        <div style={{ marginTop: 10 }}>
          <Card body className="bg-light">
            {children}
          </Card>
        </div>
      </Collapse>
    </ListGroup.Item>
  );
};

SupportIssue.propTypes = {
  children: PropTypes.node.isRequired,
  title: PropTypes.string.isRequired,
};

export default SupportIssue;
